/**
 * Video Carousel Play/Pause functionality
 */
document.addEventListener('DOMContentLoaded', () => {
  const videoWrappers = document.querySelectorAll('.video-carousel__video-wrapper');

  videoWrappers.forEach(wrapper => {
    const video = wrapper.querySelector('video');
    const playButton = wrapper.querySelector('.video-carousel__play-button');

    if (!video || !playButton) return;

    // Toggle play/pause on button click
    playButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (video.paused) {
        video.play();
        wrapper.classList.add('is-playing');
      } else {
        video.pause();
        wrapper.classList.remove('is-playing');
      }
    });

    // Update state when video plays/pauses
    video.addEventListener('play', () => {
      wrapper.classList.add('is-playing');
    });

    video.addEventListener('pause', () => {
      wrapper.classList.remove('is-playing');
    });

    // Pause video when it ends
    video.addEventListener('ended', () => {
      wrapper.classList.remove('is-playing');
    });
  });
});
